import type React from "react";

import { useTranslation } from "react-i18next";

import { styled } from "styled-components";

import { getTimezone } from "simplydo/core/dates";

const TimezoneParagraph = styled.p`
  margin-bottom: 20px;
  color: grey;
  font-style: italic;
`;

type TimezoneExplainerProps = { style?: React.CSSProperties };

const TimezoneExplainer = ({ style }: TimezoneExplainerProps) => {
  const { t } = useTranslation();

  return (
    <div style={style}>
      <TimezoneParagraph>
        {t("admin.settings.general.timezone.displayInfo", {
          timezone: getTimezone().replace(/_/g, " "),
        })}
      </TimezoneParagraph>
    </div>
  );
};

export default TimezoneExplainer;
